import {useState} from "react";
import {Dropdown, DropdownButton, InputGroup, Form, Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClose} from "@fortawesome/free-solid-svg-icons";
export default function MultiSelect(props) {
                   const elements = props.elements;

                   const [checked, setChecked] = useState([]);

                   const changeCheck = (element)=>{
                       setChecked(prevState => {
                           const indexOf = prevState.indexOf(element.value);

                           if(indexOf < 0)
                               prevState.push(element.value)
                           else
                               prevState.splice(indexOf, 1);

                           props.onChange(prevState)
                           return [...prevState];
                       })
                   }

                   const isActive = (element)=>{
                       return  checked.indexOf(element.value) > -1;
                   }

                   const getControlValue = ()=>{
                         return elements.filter(e=>checked.includes(e.value)).map(e=>e.name).join(", ");
                    }

                    const handleClear = ()=>{
                       props.onChange([]);
                       setChecked([]);
                    }

                   return (
                       <InputGroup className="mb-3">
                           <DropdownButton
                               variant="outline-secondary"
                               title={props.title}
                               id="input-group-dropdown-1"
                           >
                               {
                                   elements?.map((element, i)=>{
                                       return <Dropdown.Item key={i}  active={isActive(element)} onClick={()=>changeCheck(element)}>{element.name}</Dropdown.Item>
                                   })
                               }
                           </DropdownButton>
                           <Form.Control aria-label="Text input with dropdown button" readOnly={true} value={getControlValue()}/>
                           <Button variant="outline-secondary" id="btnClear" onClick={handleClear}>
                               <FontAwesomeIcon icon={faClose} />
                           </Button>
                       </InputGroup>
                   );
}